import '../../styles/Common.css';

/**
 *
 * @param activeTab {string} defines which link should be displayed as active.
 * Can be either <code>'urm'</code>, either <code>'tm'</code>, either <code>undefined</code>
 * @returns {JSX.Element}
 * @constructor
 */
export default function NavBar({activeTab}) {
    return (
        <>
            <nav className="navbar navbar-expand-lg">
                <div className="container-fluid">
                    <a className="navbar-brand" href="/">URM & TM Simulator</a>

                    {/* collapse button */}
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                            data-bs-target="#navbarNav">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav ms-auto">
                            <li className="nav-item">
                                <a className={activeTab === "urm"
                                    ? "nav-link active"
                                    : "nav-link"}
                                   href="/urm">Unlimited Register Machine</a>
                            </li>
                            <li className="nav-item">
                                <a className={activeTab === "tm"
                                    ? "nav-link active"
                                    : "nav-link"}
                                   href="/tm">Turing Machine</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    )
}